import { render, staticRenderFns } from "./_ide.vue?vue&type=template&id=0f94a338&"
import script from "./_ide.vue?vue&type=script&lang=js&"
export * from "./_ide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports